import React from 'react'

import { WorkorderContext, useWorkorderState } from '../../contexts'
import { DailyActivityHome } from './DailyActivityHome'

export const DailyActivityRoot = () => {
    const workorderState = useWorkorderState()

    return (
        <WorkorderContext.Provider value={workorderState}>
            <DailyActivityHome />
        </WorkorderContext.Provider>
    )
}
